// TODO: From App New
<template>
  <div
    v-if="shouldShowWizard"
    class="col-auto d-flex flex-column gap-1"
  >
    <!-- Only show Promo step for admin or owner -->
    <RouterLink
      v-if="canEditPromo"
      :to="`/sale/${saleId}/edit`"
    >
      <button class="btn btn-white d-flex align-items-center py-50 pl-0">
        <div
          style="width: 36px; height: 36px;"
          :class="isPromoActive
            ? 'd-flex align-items-center justify-content-center rounded mr-75 bg-primary text-white'
            : 'd-flex align-items-center justify-content-center rounded mr-75 border text-secondary'"
        >
          1
        </div>
        <span
          :class="isPromoActive ? 'font-weight-bolder text-primary' : 'font-weight-bolder'"
        >
          Promo
        </span>
      </button>
    </RouterLink>
    <!-- Only show Brand step for admin users -->
    <RouterLink
      v-if="isAdmin"
      :to="`/sale/${saleId}/brands`"
    >
      <button class="btn btn-white d-flex align-items-center py-50 pl-0">
        <div
          style="width: 36px; height: 36px;"
          :class="isBrandActive
            ? 'd-flex align-items-center justify-content-center rounded mr-75 bg-primary text-white'
            : 'd-flex align-items-center justify-content-center rounded mr-75 border text-secondary'"
        >
          2
        </div>
        <span
          :class="isBrandActive ? 'font-weight-bolder text-primary' : 'font-weight-bolder'"
        >
          Brand
        </span>
      </button>
    </RouterLink>
    <!-- For merchant, make Price step clickable to auto-redirect -->
    <RouterLink
      v-if="!isAdmin && merchantBrandSlug && !isPriceActive"
      :to="`/sale/${saleId}/brand/${merchantBrandSlug}/price`"
    >
      <button class="btn btn-white d-flex align-items-center py-50 pl-0">
        <div
          style="width: 36px; height: 36px;"
          class="d-flex align-items-center justify-content-center rounded mr-75 border text-secondary"
        >
          {{ priceStepNumber }}
        </div>
        <span class="font-weight-bolder">Harga</span>
      </button>
    </RouterLink>
    <!-- For admin or when currently on Price step -->
    <button
      v-else
      class="btn btn-white d-flex align-items-center py-50 pl-0"
      :disabled="!isPriceActive"
    >
      <div
        style="width: 36px; height: 36px;"
        :class="isPriceActive
          ? 'd-flex align-items-center justify-content-center rounded mr-75 bg-primary text-white'
          : 'd-flex align-items-center justify-content-center rounded mr-75 border text-secondary'"
      >
        {{ priceStepNumber }}
      </div>
      <span
        :class="isPriceActive ? 'font-weight-bolder text-primary' : 'font-weight-bolder'"
      >
        Harga
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SaleWizardNavigation',
  props: {
    saleId: {
      type: [String, Number],
      required: true,
    },
    saleData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData
    },
    isAdmin() {
      return this.userData?.role === 'admin'
    },
    merchantBrandSlug() {
      return this.userData?.merchant?.slug
    },
    isOwner() {
      return this.saleData?.is_owner || false
    },
    canEditPromo() {
      return this.isAdmin || this.isOwner
    },
    shouldShowWizard() {
      // Show wizard based on user role and permissions:
      // Admin: Always show (Promo + Brand + Price)
      // Owner: Show if can edit promo (Promo + Price)
      // Non-owner merchant: Show only on price step to indicate position
      return this.canEditPromo || this.isAdmin
    },
    currentStep() {
      const currentRoute = this.$route.name
      if (currentRoute === 'sale-edit') return 'promo'
      if (currentRoute === 'sale-brands') return 'brand'
      if (currentRoute === 'sale-setup') return 'price'
      return 'promo'
    },
    isPromoActive() {
      return this.currentStep === 'promo'
    },
    isBrandActive() {
      return this.currentStep === 'brand'
    },
    isPriceActive() {
      return this.currentStep === 'price'
    },
    priceStepNumber() {
      // Calculate step number for Price based on visible steps
      let stepNumber = 1
      if (this.canEditPromo) stepNumber += 1 // +1 if Promo is visible
      if (this.isAdmin) stepNumber += 1 // +1 if Brand is visible (admin only)
      return stepNumber
    },
  },
}
</script>
